// Salgspris er veil pris - 6 % rabatt
export const calculateBuyPrice = price => {
  /* eslint-disable-next-line */
  return new Intl.NumberFormat().format(price)
}
// Sykkel veil - rabatt 9 % /1,25 + bikefinder netto 1080 = delsum + gebyr 650= delsum/36 x 1,25 = leasing kostnad pr mnd  inkl mva
// 44999x0,91 /1,25= 32759,27 + 1080= 33839,27 x 1,0806 =36566,72 + 650=37216,72 /36=1033,80 x1,25 = 1292,25
export const calculateLeasePrice = price => {
  const priceWithDiscount = price / 1.25
  const priceWithBikeFinder = priceWithDiscount + 1080
  const priceWithPaaslag = priceWithBikeFinder * 1.0806 + 650
  const priceWithMva = (priceWithPaaslag / 36) * 1.25

  /* eslint-disable-next-line */
  return new Intl.NumberFormat().format(Math.floor(priceWithMva))
}
